import React from 'react'
import { FaGithub, FaHome, FaLinkedin, FaMailBulk, FaPhone } from 'react-icons/fa'
import { NavLink } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <FaHome size={20} style={{color:'#fff', marginRight: "2rem"}}/>
                    <div>
                        <p>kannur, kerala</p>
                        <p>India</p>
                    </div>
                </div>
                <div className="phone">
                    <h4>
                        <FaPhone size={20} style={{color:'#fff', marginRight: "2rem"}}/>
                        7559093892 
                    </h4>
                </div>
                <div className="email">
                    <h4>
                        <a href='/contact'>
                            <FaMailBulk size={20} style={{color:'#fff', marginRight: "2rem"}}/>
                            shamilkolekkara@gmail.com
                        </a>
                    </h4>
                </div>
            </div>

            <div className="right">
                <h4>About Me</h4>
                <p>This is Muhammed Shamil Ch.
                     A passionate FrontEnd Developer specialized in Reactjs.
                    Explore my portfolio to see my latest projects.
                </p>
                <div className="social">
                    {/*<FaInstagram size={30} style={{color:'#fff', marginRight: "1rem"}}/>*/
}
                    <NavLink to="https://github.com/shamil-ch">
                    <FaGithub  size={30} style={{color:'#fff', marginRight: "1rem"}} />
                    </NavLink>

                    <NavLink to="https://www.linkedin.com/in/shamil7">
                    <FaLinkedin  size={30} style={{color:'#fff', marginRight: "1rem"}}/>
                    </NavLink>
                </div>
            </div>
        </div>
        
    </div>
        
  )
}

export default Footer